import React from 'react';
import {
  GiveFeedbackContainer,
  MainContainer,
  InnerContainer,
  HeadingAndFilterCon,
  ContentContainer,
} from './style';
import { isTabletView } from '../ReactiveRender';
import MenuButton from '../MenuButton';
import ImprovedSecondarySideBar from '../ImprovedSecondarySideBar';
import FeedbackFilters from './FeedbackFilters';
import FeedbackContent from './FeedbackContent';
import Loader from '../Loader';

function FeedbackPageLayout({
  isShowMenu,
  setShowMenu,
  selectedYear,
  selectedState,
  selectedDocumentType,
  selectedSubject,
  selectedResponseType,
  sortItem,
  handleFilterChange,
  setSortItem,
  feedbackList,
  pathName,
  showPagination,
  paginationConfig,
  currentPage,
  onPageChange,
  isPaginationLoading,
  isLoading,
}) {
  const tabletView = isTabletView();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <GiveFeedbackContainer>
      <MainContainer>
        <ImprovedSecondarySideBar
          isShowMenu={isShowMenu}
          setShowMenu={setShowMenu}
        />
        <InnerContainer>
          <HeadingAndFilterCon>
            {tabletView && <MenuButton setShowMenu={setShowMenu} />}
            <FeedbackFilters
              items={feedbackList}
              selectedState={selectedState}
              selectedYear={selectedYear}
              selectedDocumentType={selectedDocumentType}
              selectedSubject={selectedSubject}
              selectedResponseType={selectedResponseType}
              sortItem={sortItem}
              onFilterChange={handleFilterChange}
              onSortChange={setSortItem}
            />
          </HeadingAndFilterCon>
          <ContentContainer>
            <FeedbackContent
              feedbackList={feedbackList}
              pathName={pathName}
              showPagination={showPagination}
              paginationConfig={paginationConfig}
              currentPage={currentPage}
              onPageChange={onPageChange}
              isPaginationLoading={isPaginationLoading}
            />
          </ContentContainer>
        </InnerContainer>
      </MainContainer>
    </GiveFeedbackContainer>
  );
}

export default FeedbackPageLayout;

